const ww = window.innerWidth
const wh = window.innerHeight

const s8StaticMode = ww / wh < 1125 / 2187 ? 'heightFit' : 'widthFit'
const s8StaticSizeObj = { mode: s8StaticMode }
if (s8StaticMode === 'heightFit') {
  s8StaticSizeObj.height = 1
} else {
  s8StaticSizeObj.width = 1
}

const s8BgMode = ww / wh < 1083 / 1591 ? 'heightFit' : 'widthFit'
const s8BgSizeObj = { mode: s8BgMode }
if (s8BgMode === 'heightFit') {
  s8BgSizeObj.height = 1
} else {
  s8BgSizeObj.width = 1
}

const margin = 10 * (wh / 667)
const s8EndH = ww / (1125 / 912)
const s8Text3H = ww * (809 * (wh / 603) / 1125) / (809 / 486)
const s8BtnH = ww * (398 * (wh / 603) / 1125) / (398 / 122)
const s8LogoH = ww * (278 / 1125) / (278 / 71)
const totalH = s8EndH + s8Text3H + s8BtnH + s8LogoH + margin * 3
const s8EndTop = (wh - totalH) / 2
const s8Text3Top = s8EndTop + s8EndH + margin
const s8BtnTop = s8Text3Top + s8Text3H + margin
const s8LogoTop = s8BtnTop + s8BtnH + margin

const sprites = {
  s8_bg: {
    size: s8BgSizeObj,
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_static2: {
    size: { mode: 'widthFit', width: 1 },
    position: { x: 0, y: 1 },
    anchor: 'bottomLeft'
  },
  s8_static: {
    size: s8StaticSizeObj,
    position: { x: 0, y: 1 },
    anchor: 'bottomLeft'
  },
  s8_text: {
    size: { mode: 'heightFit', height: 833 / 2436 },
    position: { x: 0.9, y: 0.1 },
    anchor: 'topRight'
  },
  s8_me: {
    key: 's8_me1',
    size: { mode: 'heightFit', height: 1120 / 2436 },
    position: { x: 742 / 1125, y: 1593 / 2436 },
    anchor: 'center'
  },
  s8_walk: {
    key: 's8_walk1',
    size: { mode: 'heightFit', height: 1120 / 2436 },
    position: { x: 0.5, y: 1550 / 2436 },
    anchor: 'center'
  },
  s8_talk: {
    size: { mode: 'heightFit', height: 457 / 2436 },
    position: { x: 0.38, y: 0.44 },
    anchor: 'bottomRight'
  },
  s8_star: {
    size: { mode: 'heightFit', height: 1428 / 2436 },
    position: { x: 0.5, y: 0.5 },
    anchor: 'center'
  },
  s8_text2: {
    size: { mode: 'heightFit', height: 587 / 2436 },
    position: { x: 0.5, y: 0.5 },
    anchor: 'center'
  },
  s8_bird1: {
    size: { mode: 'heightFit', height: 247 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird2: {
    size: { mode: 'heightFit', height: 473 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird3: {
    size: { mode: 'heightFit', height: 547 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird4: {
    size: { mode: 'heightFit', height: 1210 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird5: {
    size: { mode: 'heightFit', height: 2082 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird6: {
    size: { mode: 'heightFit', height: 1707 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird7: {
    size: { mode: 'heightFit', height: 1593 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird8: {
    size: { mode: 'heightFit', height: 1604 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird9: {
    size: { mode: 'heightFit', height: 1161 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_bird10: {
    size: { mode: 'heightFit', height: 2028 / 2436 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s8_js: {
    size: { mode: 'widthFit', width: 1 },
    position: { x: 0.5, y: s8EndTop / wh },
    anchor: 'top'
  },
  s8_text3: {
    size: { mode: 'widthFit', width: 809 * (wh / 603) / 1125 },
    position: { x: 0.5, y: s8Text3Top / wh },
    anchor: 'top'
  },
  s8_btnagain: {
    size: { mode: 'widthFit', width: 398 * (wh / 603) / 1125 },
    position: { x: 0.45, y: s8BtnTop / wh },
    anchor: 'topRight'
  },
  s8_btnshare: {
    size: { mode: 'widthFit', width: 398 * (wh / 603) / 1125 },
    position: { x: 0.55, y: s8BtnTop / wh },
    anchor: 'topLeft'
  },
  s8_logo: {
    size: { mode: 'widthFit', width: 278 / 1125 },
    position: { x: 0.5, y: s8LogoTop / wh },
    anchor: 'top'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s8/sprites.js